import { AddressBadge } from '@/components/molecules'
import { MODALS } from '@/constants'
import { useModals } from '@/hooks'

export const Account = ({ address, symbols }) => {
  const { openModal } = useModals()

  const handleOpenAccountModal = () => {
    openModal(MODALS.ACCOUNT)
  }

  return address ? (
    <>
      <AddressBadge
        cursor={'pointer'}
        symbols={symbols}
        onClick={handleOpenAccountModal}
        address={address}
      />
    </>
  ) : null
}
